import React, { FC } from 'react';
import { NumberInput, minValue, useTranslate } from 'react-admin';
import { H3 } from '~/components';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { l, validateInteger } from '~/utils/solutions';

interface ApprovalCasesFormProps {
  keyName: string;
}

export const ApprovalCasesForm: FC<ApprovalCasesFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  return (
    <>
      <H3 topSpacing={0} bottomSpacing={2}>
        {t('approvalCasesTitle')}
      </H3>
      <NumberInput
        label={t('approvalCasesDefaultExpirySeconds')}
        source={`${keyName}.settings.defaultExpirySeconds`}
        min={1}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
      <NumberInput
        label={t('approvalCasesClaimBatchSize')}
        source={`${keyName}.settings.claimBatchSize`}
        min={1}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
      <NumberInput
        label={t('approvalCasesWatchdogTimeoutMinutes')}
        source={`${keyName}.settings.watchdogTimeoutMinutes`}
        min={1}
        step={1}
        validate={[minValue(1), validateInteger]}
        className={classes.inputWidth}
      />
    </>
  );
};
